import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = {
    dismissAfter: Number,
  };

  connect() {
    // Show toast
    requestAnimationFrame(() => {
      this.element.classList.add(...this.showClasses);
    });

    // Auto dismiss
    if (this.dismissAfterValue > 0) {
      this.autoDismissTimeout = setTimeout(() => {
        this.dismiss();
      }, this.dismissAfterValue);
    }
  }

  dismiss() {
    this.element.classList.remove(...this.showClasses);
    this.element.classList.add(...this.hideClasses);

    // Remove element after animation
    setTimeout(() => {
      this.element.remove();
    }, 300);
  }

  disconnect() {
    if (this.autoDismissTimeout) {
      clearTimeout(this.autoDismissTimeout);
    }
  }

  get showClasses() {
    return this.data.get("showClass").split(" ");
  }

  get hideClasses() {
    return this.data.get("hideClass").split(" ");
  }
}
